import { closeAccountPortal, useRuntimeInfo } from '@account/account-portal/lib'
import { GlModal } from '@adl/component-modal'
import { useDevice } from '@crystal/core'
import { FC } from 'react'

import styles from './portal-layout.module.scss'

type PortalLayoutProps = { className?: string; isInlineView?: boolean; isSSR?: boolean }

export const PortalLayout: FC<PortalLayoutProps> = ({ children, className, isInlineView, isSSR }) => {
  const { isModalVisible } = useRuntimeInfo()
  const { isMobile } = useDevice()

  const onClose = () => {
    closeAccountPortal()
  }

  return !isInlineView ? (
    <div id="account-portal-modal">
      <GlModal
        id="mf-account-portal"
        title="Account Portal MF Layout"
        showTitle={false}
        closeButtonLabel=""
        htmlAttrs={{
          closeButton: {
            name: 'account-portal-close',
          },
        }}
        disablePortal
        open={isModalVisible || isSSR}
        className={`${styles['account-portal-modal']} ${className || ''}`}
        size={isMobile ? 'full-mobile' : 'small'}
        onClose={onClose}>
        {children}
      </GlModal>
    </div>
  ) : (
    <div id="account-portal-inline" className={className}>
      {children}
    </div>
  )
}
